import React from 'react';

import {
  DrawerBody as ChakraDrawerBody,
  forwardRef,
  useStyleConfig,
} from '@chakra-ui/react';

import { DrawerBodyProps } from './types';

export const DrawerBody = forwardRef<DrawerBodyProps, 'div'>((props, ref) => {
  const styles = useStyleConfig('DrawerBody', { ...props });
  return <ChakraDrawerBody ref={ref} sx={styles} {...props} />;
});
